import React, { Component } from 'react';
import Rotation from './../../../controllers/rotation.controller';
import batches, { Batches } from './batches';
import ImportHelper from './../../../utils/import.helper';
import ArrayHelper from './../../../utils/array.helper';
import PropTypes from 'prop-types';

class Camera extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            images: [],
            tempimages: [],
            cache: {},
            loading: false,
            loadedImages: 0,
            batch: 0,
            loadAfterRotation: false,
            transition: false
        }

        this._rotationcontrol = React.createRef();
        this.index = [0,2,3,4,6,8,9,10,12,14,15,16,18,20,21,22,24,26,27,28,30,32,33,34,36,38,39,40,42,44,45,46,48,50,51,52,54,56,57,58,60,62,63,64,66,68,69,70]
    }

    handleImageLoaded(loadedImages){

        if(Batches[this.state.batch]){
            if(loadedImages % (this.props.is180 ? Batches[this.state.batch].altlimit : Batches[this.state.batch].limit) === 0){
                
                for (let i = 0; i < this.state.tempimages.length; i++) {
                    this.setState(prevState => ({
                        images: ArrayHelper.addAfter(prevState.images, 
                                    (this.props.is180 ? Batches[this.state.batch].alteval(i, this.state.images.length): Batches[this.state.batch].eval(i, this.state.images.length)),
                                    this.state.cache[this.state.tempimages[i]]),
                        loading: false
                    }))
                }
                
    
                this.setState(prevState => ({
                    batch: prevState.batch + 1
                }), function(){
                    if(this.state.batch < Batches.length){
                        this.loadImages(this.state.batch);
                    } else {
                                                
                    }})                
                
            }
        }
    }
    
    renderImage(index) {

        if(this.state.images[index] instanceof Promise){
            throw this.state.images[index];
        }
        
        return (
            <img 
                src={this.state.images[index].src} 
                key={'img-'+index}    
                alt =""
            />
        );
    }

    

    loadImages(offset){
        let {links} =  this.props;

        if(Batches[offset] === undefined){
            return;
        }

        this.setState({
            tempimages: links.filter((value, i) => {
                return this.props.is180 ? Batches[offset].altconstraint(i) : Batches[offset].constraint(i);
            }),
            loading: false,
            transition: false
        }, 
        () => {
            this.setState({
                loading: true
            })
            this.cacheImages(this.state.tempimages);
        })
        
    }

    cacheImages (srcArray){

        let self = this;

        srcArray.forEach(src => {
            new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;
                
                var stateCopy = Object.assign({}, self.state);
                stateCopy.cache[src] = img;
                self.setState(stateCopy);
                img.onload = (event) => {
                    if(!self._isMounted)
                    {
                        return; 
                    }

                    this.setState(prevState => ({
                        loadedImages: prevState.loadedImages + 1
                    }), 
                    ()=> {
                        self.handleImageLoaded(this.state.loadedImages);
                    })
                    

                    //if(Object.keys(this.state.cache).length == 6){
                    //if(this.props.is180){
                        if(this.props.secondary){

                            this.props.onReady();

                        } 
                        else
                        {
                            //if(this.state.batch === 2 && this.state.loadedImages > 24){
                            if(this.state.batch === 1 && this.state.loadedImages === 12){
                                this.props.onReady();
                            }
                        }
                    //}
                        
                    //}
                }
                img.onerror = (err) => {
                    reject();
                }

            }).catch((e) => {

            });

        });
        this.setState({
            loading: false
        })
    }

    componentDidMount(){

        this._isMounted = true;

        this.setState({
            loading: true
        })

        if(this.state.images.length === 0){
            this.loadImages(0);
        }
        
    }

     

    onRotationEnded = () => {
        
        let { handleStartTransicion} = this.props;
        
        if(this.props.secondary){
            this.props.handleRotateForBubbleEnded();
        } 
        else 
        {
            handleStartTransicion();
        }
        
        
        
        
    }

    onChange = (current) =>
    {   
        if(!this._isMounted)
        {
            return; 
        }
        // este cambio puede dañar todo, tengamslo en cuenta
        if(this.props.handleAngleUpdate /*&& this.props.secondary*/){
            
            if (this.props.is180){
                if (this.state.loadedImages < 24) 
                {
                    this.props.handleAngleUpdate(current * 3)
                }
                else if(this.state.loadedImages < 36) 
                { 
                    this.props.handleAngleUpdate(this.index[current])
                } 
                else if (this.state.loadedImages < 36)
                {
                    this.props.handleAngleUpdate(current)
                }
                else {
                    this.props.handleAngleUpdate(current)
                }
                
            }
            else {
                if(this.props.secondary){
                    if (this.state.loadedImages < 12) 
                    {
                        // during first load [0-12)
                        this.props.handleAngleUpdate((current * 24) % 72 )
                    }
                    else if(this.state.loadedImages < 24) 
                    { 
                        // [12-24)
                        this.props.handleAngleUpdate((current * 6) % 72 )
                    } 
                    else if (this.state.loadedImages < 48)
                    {
                        // [24-48)
                        this.props.handleAngleUpdate(current * 3 % 72)
                    }
                    else if (this.state.loadedImages < 72)
                    {
                        // [48-72)
                        this.props.handleAngleUpdate(this.index[current] % 72)
                    }
                    else if (this.state.loadedImages < 144)
                    {
                        // [72]
                        this.props.handleAngleUpdate(current)
                    } 
                    else 
                    {
                        // default
                        this.props.handleAngleUpdate(current)
                    }
                } else {
                    if (this.state.loadedImages < 12) 
                    {
                        // during first load [0-12)
                        this.props.handleAngleUpdate((current * 24) % 72 )
                    }
                    else if(this.state.loadedImages < 24) 
                    { 
                        // [12-24)
                        this.props.handleAngleUpdate((current * 6) % 72 )
                    } 
                    else if (this.state.loadedImages < 48)
                    {
                        // [24-48)
                        this.props.handleAngleUpdate(current * 3 % 72)
                    }
                    else if (this.state.loadedImages < 72)
                    {
                        // [48-72)
                        this.props.handleAngleUpdate(this.index[current] % 72)
                    }
                    else if (this.state.loadedImages < 144)
                    {
                        // [72]
                        this.props.handleAngleUpdate(current)
                    } 
                    else 
                    {
                        // default
                        this.props.handleAngleUpdate(current)
                    }
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState){
        
        let {links, isPreTransition, initFramePOI} = this.props;

        

        if(prevProps.links !== links){

            

            if(this.props.secondary){
                this.setState({
                    batch: 0,
                    images: [],
                    loading: true,
                    cache: {},
                    loadedImages: 0,
                    transition: true
                }, () => {
                    if(this.state.images.length === 0){
                        this.loadImages(0);
                    }
                })
            }

            if(this.props.shouldRotate){
                
                this.setState({
                    loadAfterRotation: true
                })
            }
            
        }
        
        if(this.props.secondary){
            if(prevProps.rotateForBubble !== this.props.rotateForBubble){
                if(this.props.rotateForBubble)
                {
                    this._rotationcontrol.current.moveTo(this.props.bubbleAngle)
                }
            }
        } else {
            if(prevProps.isPreTransition !== isPreTransition){
                if(isPreTransition)
                {
                    this._rotationcontrol.current.moveTo(initFramePOI)
                }
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        
    }

    render() {
        return (
            <div className={this.state.transition && !this._isMounted ? "fade-out":"fade-in"}>
                {/* <h3>rotation panel</h3> */}
                {/* <button className="back-btn btn-move-to" onClick={() => {
                    this._rotationcontrol.current.moveTo(Math.floor(Math.random()*(144)))
                }}
                >Move to</button> */}
                <div className="black-fallback">
                    {/*
                        this.state.loading ? 
                        <p>Loading</p>:
                        this.state.images.map((url, index) => <p style={{color: '#fff', zIndex: 123123123, position: 'absolute', marginLeft: '20%', marginTop: (index * 3) + '%'}}>{index}</p>)
                    */}
                </div>
                {
                    this._isMounted ? 
                    <Rotation
                    cycle={!this.props.is180}
                    is180={this.props.is180}
                    reverse={true}
                    ref={this._rotationcontrol}
                    onRotationEnded={this.onRotationEnded}
                    className={'camera-frames'}
                    onChange = {this.onChange}
                    initFrame = {this.props.secondary ? this.props.initFramePOI : 0}
                    secondary = {this.props.secondary}
                    notifyZoom = {this.props.notifyZoom}
                    notifyLeftOffset = {this.props.notifyLeftOffset}
                    notifyTopOffset = {this.props.notifyTopOffset}
                    notifyZoomAndOffsets = {this.props.notifyZoomAndOffsets}
                >
                    {
                        this.state.loading ? 
                        <p>Loading</p>:
                        this.state.images.map((url, index) => this.renderImage(index))
                    }
                    </Rotation>
                    :
                    null
                }
            </div>
        );
      
    }
}

Camera.propTypes = {
    useSubdirectories: PropTypes.bool,
    is180: PropTypes.bool,
    shouldRotate: PropTypes.bool,
    handleAngleUpdate: PropTypes.func,
    onReady: PropTypes.func,
    secondary: PropTypes.bool,
    handleRotateForBubbleEnded: PropTypes.func
}

Camera.defaultProps = {
    useSubdirectories: false,
    initFramePOI: 0,
    isPreTransition: false,
    is180: false,
    shouldRotate: false,
    handleAngleUpdate: null,
    onReady: () => {},
    secondary: false
}

export default Camera;
